import { render, staticRenderFns } from "./ResourcesWrite.vue?vue&type=template&id=4e4e85f3&"
import script from "./ResourcesWrite.vue?vue&type=script&lang=js&"
export * from "./ResourcesWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports